var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyJobsIconW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.229 6.1125C6.229 5.11839 7.03489 4.3125 8.029 4.3125H14.0123C15.0065 4.3125 15.8123 5.11839 15.8123 6.1125V11.0208H8.029C7.03489 11.0208 6.229 10.2149 6.229 9.22083V6.1125Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3125 12.8205C4.3125 11.8264 5.11839 11.0205 6.1125 11.0205H11.9792V18.6872H6.1125C5.11839 18.6872 4.3125 17.8813 4.3125 16.8872V12.8205Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.979 11.0205H17.8457C18.8398 11.0205 19.6457 11.8264 19.6457 12.8205V16.8872C19.6457 17.8813 18.8398 18.6872 17.8457 18.6872H11.979V11.0205Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8125 11.0205V13.8955",
    stroke: "white",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.146 11.0205V13.8955",
    stroke: "white",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.021 4.3125V7.1875",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyJobsIconW);
export default __webpack_public_path__ + "static/media/MyJobsIconW.41e2188bca27d33bd60c7cde82778ceb.svg";
export { ForwardRef as ReactComponent };